import { Button, Form, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import FloatingInput from "../../../components/common/float-input/FloatInput";

import { useDispatch, useSelector } from "react-redux";
import { login } from "../../../store/thunks/authThunk";
import { Link, useNavigate } from "react-router-dom";
import "./LoginFields.css";
import { nanoid } from "nanoid";
import { setBreadcrumbs } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
const { Text } = Typography;
const LoginFields = ({ navigateTo }) => {
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const [errorMessage, setErrorMessage] = useState("");
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
    "--label-margin-top": "-6px",
  };
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { isLoading, loginStatus, isAuthenticated, token, userType } =
    useSelector((state) => state.login);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = (e) => {
    dispatch(login(e)).then((e) => {
      if (e.payload?.status == 0) {
        setErrorMessage(
          e.payload?.message || "Login failed. Please try again.",
        );
      }
    });
  };

  useEffect(() => {
    if (loginStatus === "success" && token) {
      localStorage.setItem("token", token);
      const prevEmail = sessionStorage.getItem("lastEmail");
      const prevUserType = sessionStorage.getItem("lastUserType");
      const savedBreadcrumbs = sessionStorage.getItem("breadcrumbs");
      const currentEmail = formData.email;
      const currentUserType = userType;
      // Redirect based on user type
      const redirectPath = sessionStorage.getItem("redirectPath");
      const lastChatUrl = sessionStorage.getItem("chatPostLogin");
      if (lastChatUrl) {
        sessionStorage.removeItem("chatPostLogin");
        const basePath = currentUserType === "owner" ? "/seller" : "/buyer";
        sessionStorage.setItem("chatRefreshAfterLogin", "true");
        navigate(`${basePath}${lastChatUrl}`);
        return;
      }
      const campaignPostLoginRedirect = sessionStorage.getItem(
        "campaignPostLoginRedirect",
      );
      if (campaignPostLoginRedirect) {
        sessionStorage.removeItem("campaignPostLoginRedirect");
        navigate(campaignPostLoginRedirect, {
          replace: true,
        });
        return;
      }
      if (
        redirectPath &&
        prevEmail === currentEmail &&
        prevUserType === currentUserType
      ) {
        if (savedBreadcrumbs) {
          dispatch(setBreadcrumbs(JSON.parse(savedBreadcrumbs)));
        }
        navigate(redirectPath);
        sessionStorage.removeItem("redirectPath");
      } else {
        if (currentUserType === "owner") {
          dispatch(
            setBreadcrumbs([{ title: "Dashboard", path: "/seller/dashboard" }]),
          );
          navigate("/seller/dashboard");
        } else {
          dispatch(
            setBreadcrumbs([
              { title: "Dashboard", path: "/buyer/dashboard" },
              { title: "Shop", path: "/buyer/products" },
            ]),
          );
          navigate("/buyer/products");
        }
      }
      sessionStorage.setItem("lastEmail", currentEmail);
      sessionStorage.setItem("lastUserType", currentUserType);
      const uniqueSessionId = nanoid();
      sessionStorage.setItem("sessionId", uniqueSessionId);
    } else if (loginStatus === "failed" || loginStatus === "idle") {
    }
  }, [loginStatus, isAuthenticated, token, userType, navigate]);
  const formValues = Form.useWatch([], form);
  const isLoginDisabled = () => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
    const requiredFields = ["email", "password"];
    const hasEmptyFields = requiredFields.some((field) => {
      const value = form.getFieldValue(field);
      return (
        value === undefined ||
        value === null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0)
      );
    });
    return hasErrors || hasEmptyFields;
  };
  return (
    <div className="login-form-wrapper">
      <Text className="login-title">Welcome Back!</Text>
      <Text className="login-subtitle">
        Access your account to manage campaigns, track results, and explore new
        opportunities.
      </Text>
      <Form className="login-form" form={form} onFinish={handleSubmit}>
        <Form.Item
          name="email"
          rules={[
            { required: true, message: "Email is required!" },
            { type: "email", message: "Please enter a valid email address!" },
          ]}
        >
          <FloatingInput
            className="billboard-input-feild billboard-password-field"
            label={
              <>
                {`Email `}
                {star}
              </>
            }
            customStyles={floatingInputStyles}
            value={formData?.email}
            onChange={(e) => {
              setFormData({ ...formData, email: e.target.value });
              setErrorMessage("");
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                form.submit();
              }
            }}
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: "Password is required!" }]}
        >
          <FloatingInput
            className="billboard-input-feild"
            label={
              <>
                {`Password `}
                {star}
              </>
            }
            isPassword={true}
            customStyles={floatingInputStyles}
            value={formData?.password}
            onChange={(e) => {
              setFormData({ ...formData, password: e.target.value });
              setErrorMessage("");
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                form.submit();
              }
            }}
          />
        </Form.Item>
        <span style={{ color: "#d2042d" }}>{errorMessage}</span>
        <Form.Item valuePropName="checked" className="remember-me">
          <Row justify="end">
            <Link
              className="forgot-password"
              onClick={() => navigateTo("forgotPassword")}
            >
              Forgot Password?
            </Link>
          </Row>
        </Form.Item>

        <Button
          type="primary"
          id="welcome_back_login_btn"
          className={`login-button billboard-button-2 ${
            isLoginDisabled() ? "disabled-opacity" : ""
          }`}
          loading={isLoading}
          disabled={isLoginDisabled()}
          onClick={() => form.submit()}
        >
          {isLoading ? "Signing In..." : "Sign In"}
        </Button>

        <div className="sign-up-text">
          New here? <a href="/signup">Sign Up Now</a> and start your journey!
        </div>
      </Form>
    </div>
  );
};

export default LoginFields;
